import { makeAutoObservable } from "mobx"

export default class DraftShareChecklistItem {

  constructor(checklistItem = {}) {
    this.id = checklistItem.id
    this.text_de = checklistItem.text_de || ''
    this.text_en = checklistItem.text_en || ''
    this.position = checklistItem.position || 0
    this.reviewed_status = checklistItem.reviewed_status

    makeAutoObservable(this)
  }

  text(locale) {
    const primary = locale === 'de' ? this.text_de : this.text_en
    const fallback = locale === 'de' ? this.text_en : this.text_de
    return primary || fallback
  }
}
